import { Box, styled } from '@mui/material/';

export const StyledContainer = styled(Box)(({}) => ({
  display: 'flex',
  alignItems: 'inherit',
  width: '100%',
}));
